const en_trans_itemout = {
    "": "item out",

    label: {
        sn_upload_text: "Download Excel template for Serial Number upload",
        select_doc: "Please select a document to print...",
        btn_print_basic: "Basic Print",
        btn_print_full: "Full Print",
    },

    error: {
        create: "Failed to create item out",
        edit: "Failed to update item out",
        sn_over_qty: "Quantity exceeds available stock",
        sn_aviable: "Item with serial number {{sn}} has already left the warehouse or is not registered.",
    },

    success: {
        create: "Item out created successfully",
        edit: "Item out updated successfully",
    },
}

export default en_trans_itemout;